import { EnvObject } from './types'
import { environments } from './Environments'
import { isBrowser } from '../../../Utils'
/*
 * Provider to get correct urls and settings for the different environments
 * based on host.
 */

export const EnvironmentUrlProvider = () => {
    const env = environments;

    // Get current url from the browser, return empty string if in node
    const currentHostname = isBrowser ? window.location.hostname : '';

    // Check if one of the defined hosts exists in the current url
    function UrlExistsInArray(currentUrl: string): any {
        return env.filter((envItem: any) => {
            if (envItem.host.includes(currentUrl)) {
                return envItem;
            }
        });
    }

    // Return Config for the env
    function GetEnvironmentConfig(): EnvObject {
        const match = UrlExistsInArray(currentHostname)[0];

        if (!match || (match && !match.env)) {
            throw Error('Missing environment urls.');
        }

        return match;
    }

    return {
        GetEnvironmentConfig,
    }
}

export default EnvironmentUrlProvider();
